import { customAxiosBE } from "../config";
import { parsePaginationParams } from "../../utils/other";

// ==================== CRUD ====================

/**
 * Dohvata sve stavke za operatora (paginacija)
 */
export async function getAllItemsAPI(params) {
    const parsedParams = parsePaginationParams(params);
    return customAxiosBE.get(`/items?${parsedParams}`);
}

/**
 * Dohvata sve stavke kao listu (bez paginacije)
 */
export async function getAllItemsListAPI() {
    return customAxiosBE.get(`/items/list`);
}

/**
 * Dohvata sve stavke sa cenama iz aktivnog cenovnika.
 * Koristi se za StationServices stranicu.
 */
export async function getItemsWithPricesAPI() {
    return customAxiosBE.get(`/items/with-prices`);
}

/**
 * Dohvata stavku po ID-u
 */
export async function getItemByIdAPI(id) {
    return customAxiosBE.get(`/items/${id}`);
}

/**
 * Kreira novu stavku
 */
export async function createItemAPI(data) {
    return customAxiosBE.post(`/items`, data);
}

/**
 * Azurira postojecu stavku
 */
export async function updateItemAPI(id, data) {
    return customAxiosBE.put(`/items/${id}`, data);
}

/**
 * Brise stavku
 */
export async function deleteItemAPI(id) {
    return customAxiosBE.delete(`/items/${id}`);
}

// ==================== Specijalne metode ====================

/**
 * Dohvata aktivne stavke
 */
export async function getActiveItemsAPI() {
    return customAxiosBE.get(`/items/active`);
}

/**
 * Pretraga stavki po imenu ili kodu
 */
export async function searchItemsAPI(searchTerm) {
    return customAxiosBE.get(`/items/search`, {
        params: { q: searchTerm }
    });
}

// ==================== Rate Card veze ====================

/**
 * Dohvata sve stavke za odredjeni cenovnik (sa cenama)
 */
export async function getItemsByRateCardAPI(rateCardId) {
    return customAxiosBE.get(`/items/by-rate-card/${rateCardId}`);
}

/**
 * Dodaje stavku u cenovnik sa cenom
 * @param {number} itemId - ID stavke
 * @param {number} rateCardId - ID cenovnika
 * @param {object} data - { price: number, discountPct?: number, discountAbs?: number }
 */
export async function assignItemToRateCardAPI(itemId, rateCardId, data) {
    return customAxiosBE.post(`/items/${itemId}/rate-cards/${rateCardId}`, data);
}

/**
 * Azurira vezu stavke sa cenovnikom (cenu i popuste)
 */
export async function updateRateCardItemAPI(itemId, rateCardId, data) {
    return customAxiosBE.put(`/items/${itemId}/rate-cards/${rateCardId}`, data);
}

/**
 * Uklanja stavku iz cenovnika
 */
export async function removeItemFromRateCardAPI(itemId, rateCardId) {
    return customAxiosBE.delete(`/items/${itemId}/rate-cards/${rateCardId}`);
}

// ==================== Upload slike ====================

/**
 * Upload slike za stavku
 */
export async function uploadItemImageAPI(itemId, file) {
    const formData = new FormData();
    formData.append('image', file);
    return customAxiosBE.post(`/items/${itemId}/image`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
    });
}
